<div class="lk-pair" [class.lk-pair--playable]="playable()" [attr.data-test-id]="testId() + '-pair'">
  <div class="lk-pair__row">
    <button
      type="button"
      class="lk-pair__arrow"
      [attr.data-test-id]="testId() + '-earlier'"
      [disabled]="!state.canShiftEarlier()"
      [attr.aria-label]="t('panel.pairEarlier')"
      [attr.title]="t('panel.pairEarlier')"
      (click)="state.shiftPair(-1)"
    >
      <i eIcon icon="chevron-left" family="solid"></i>
    </button>

    <e-segmented-toggle
      block
      class="lk-pair__toggle"
      [size]="size()"
      [testId]="testId()"
      [groupLabel]="t('panel.periodLabel')"
      [options]="options()"
      [value]="state.periodId()"
      (valueChange)="selectPeriod($event)"
    ></e-segmented-toggle>

    <button
      type="button"
      class="lk-pair__arrow"
      [attr.data-test-id]="testId() + '-later'"
      [disabled]="!state.canShiftLater()"
      [attr.aria-label]="t('panel.pairLater')"
      [attr.title]="t('panel.pairLater')"
      (click)="state.shiftPair(1)"
    >
      <i eIcon icon="chevron-right" family="solid"></i>
    </button>

    @if (playable()) {
      <button
        type="button"
        class="lk-pair__arrow lk-pair__play"
        [class.is-playing]="playing()"
        [attr.data-test-id]="testId() + '-play'"
        [attr.aria-pressed]="playing()"
        [attr.aria-label]="t(playing() ? 'panel.pairPause' : 'panel.pairPlay')"
        [attr.title]="t(playing() ? 'panel.pairPause' : 'panel.pairPlay')"
        (click)="togglePlay()"
      >
        <i eIcon [icon]="playing() ? 'pause' : 'play'" family="solid"></i>
      </button>
    }
  </div>

  <div class="lk-pair__selects">
    @for (slot of slots; track slot) {
      <ng-select
        class="lk-pair__select"
        [attr.data-test-id]="testId() + '-select-' + slot"
        [attr.aria-label]="t(slot === 0 ? 'panel.pairSelectLeft' : 'panel.pairSelectRight')"
        [items]="periodItems()"
        bindValue="id"
        bindLabel="label"
        [clearable]="false"
        [searchFn]="searchPeriod"
        [ngModel]="state.periodPair()[slot]"
        (ngModelChange)="setSlotPeriod(slot, $event)"
      >
        <ng-template ng-label-tmp let-item="item">
          <span class="lk-pair__select-label" [attr.title]="item.tooltip">{{ item.crosses }}</span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <span class="lk-pair__option" [class.is-current-era]="item.isCurrentEra" [attr.title]="item.tooltip">
            <span class="lk-pair__option-years">{{ item.label }}</span>
            <span class="lk-pair__option-crosses">{{ item.crosses }}</span>
          </span>
        </ng-template>
      </ng-select>
    }
  </div>
</div>
